import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { CreateEmailTemplateRPC } from "./createEmailTemplateRPC";

export class CreateEmailTemplateRPCClientImpl extends CreateEmailTemplateRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: CreateEmailTemplateRPC.Request): Promise<LeoRPCResult<CreateEmailTemplateRPC.Response, CreateEmailTemplateRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/CreateEmailTemplate",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      CreateEmailTemplateRPC.ResponseDTO,
      CreateEmailTemplateRPC.Errors.ErrorsDTO,
      CreateEmailTemplateRPC.Response,
      CreateEmailTemplateRPC.Errors.Errors
    >(
      response,
      "email-cycle/CreateEmailTemplate",
      CreateEmailTemplateRPC.Response.fromDTO,
      CreateEmailTemplateRPC.Errors.fromDTO
    );
  }
}
